import React from 'react';

export const LazyCalculator = React.lazy(
  () =>
    import(
      /* webpackChunkName: 'Calculator' */ '../../installmentCalculator/InstallmentCalculator/InstallmentCalculator'
    ),
);
